angular.module('gym.subscriptions').controller('SubscriptionsCtrl', ["$scope", "$rootScope", "$stateParams", "$state", "$http", "$timeout", "flash", "loadingAnimation", "GTMService", function($scope, $rootScope, $stateParams, $state, $http, $timeout, flash, loadingAnimation, GTMService) {
  var getCurrentPlanKey, getSwithedPlanId, loadPaymentMethod, loadSubscriptionData;
  $scope.plan = {};
  $scope.gym = {
    isLoading: true
  };
  $scope.paymentMethod = {};
  GTMService.trackPage('Subscription');
  loadSubscriptionData = function() {
    var url;
    url = `/subscriptions?gymId=${$stateParams.gymId}`;
    return $http.get(url).then(function(response) {
      $scope.gym.isLoading = false;
      $scope.gym = response.data.gym_data;
      $scope.plan = response.data.plan_data;
      if (!$scope.gym.on_trial_period && !$scope.gym.gym_is_subscribed) {
        return GTMService.push({
          event_action: 'Signed In After Trial Expired',
          event_category: 'Lifecycle Event',
          event: 'custom_event'
        });
      }
    }, function() {
      return $scope.gym.isLoading = false;
    });
  };
  $scope.isFreemium = function() {
    var frequency, id;
    id = $scope.gym.plan_id;
    frequency = $scope.gym.subscription_payment_frequency;
    return frequency && $scope.plan[frequency][id] === 0;
  };
  $scope.paymentMethodProvided = function() {
    return !!$scope.paymentMethod.last_4 && !$scope.paymentMethod.isLoading;
  };
  $scope.paymentExists = function(val) {
    return parseFloat(val);
  };
  loadPaymentMethod = function() {
    var url;
    url = `/subscription_payment_methods?gymId=${$stateParams.gymId}`;
    $scope.paymentMethod.isLoading = true;
    return $http.get(url).then(function(response) {
      return $scope.paymentMethod = response.data[0];
    });
  };
  loadSubscriptionData();
  loadPaymentMethod();
  getCurrentPlanKey = function() {
    var plans;
    plans = _.pairs($scope.plan.plan_id_map);
    return _.find(plans, function(item) {
      return item[0] === $scope.gym.plan_id;
    })[0];
  };
  $scope.planPrice = function(frequency) {
    var currentPlanKey, key;
    currentPlanKey = getCurrentPlanKey();
    key = currentPlanKey.indexOf('_annual') > -1 ? currentPlanKey.replace('_annual', '') : currentPlanKey;
    return $scope.plan[frequency][key];
  };
  getSwithedPlanId = function() {
    var currentPlanKey, newPlanKey;
    currentPlanKey = getCurrentPlanKey();
    newPlanKey = $scope.gym.subscription_payment_frequency === 'annual' ? currentPlanKey.replace('_annual', '') : `${currentPlanKey}_annual`;
    return $scope.plan.plan_id_map[newPlanKey];
  };
  $scope.onChangePlanClicked = function() {
    $state.go('gym.subscription.tab', {
      tab: 'subscriptions'
    });
    return GTMService.trackPage('Subscription', 'Change Plans');
  };
  $scope.setPaymentMethod = function(paymentMethod) {
    var action;
    action = $scope.paymentMethod.last_4 ? 'Subscribed' : 'Subscription Payment Method Changed';
    GTMService.push({
      event_action: action,
      event_category: 'Lifecycle Event',
      event: 'custom_event'
    });
    GTMService.trackPage('Subscription', 'Save Card');
    return $scope.paymentMethod = paymentMethod;
  };
  return $scope.selectPaymentFrequency = function(frequency) {
    var params, url;
    if ($scope.gym.subscription_payment_frequency === frequency) {
      return;
    }
    url = `/subscriptions/${window.currentUser.id}?gym_id=${$stateParams.gymId}`;
    params = {
      braintree_customer: {
        plan: getSwithedPlanId()
      }
    };
    loadingAnimation.show();
    $scope.gym.subscription_payment_frequency = frequency;
    $scope.gym.subscription_payment_amount = $scope.planPrice(frequency);
    return $http.put(url, params).then(function() {
      loadSubscriptionData();
      return loadingAnimation.hide();
    }, function() {
      loadingAnimation.hide();
      loadSubscriptionData();
      return flash.error = "There was an error processing the request.";
    });
  };
}]);
